import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Table, Modal } from 'react-bootstrap';
import Sidebar from '../../components/Sidebar';
import axios from 'axios';
import { Formik, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import toast from 'react-hot-toast';

const BASE_URL = process.env.REACT_APP_BASE_URL; // Adjust the base URL as needed


const patientId = localStorage.getItem('patient_id');

const fetchData = async (url, params = {}, headers = {}) => {
  try {
    const response = await axios.get(url, { params, headers });
    return response.data;
  } catch (error) {
    console.error(
      `Error fetching data from ${url}:`,
      error.response?.data || error.message,
    );
    throw error;
  }
};

const Appointment = () => {
  const [appointments, setAppointments] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [doctors, setDoctors] = useState([]);
  const [availableTimes, setAvailableTimes] = useState([]);
  const [hospitalId, setHospitalId] = useState('');
  const [subHospitalId, setSubHospitalId] = useState('');
  const [receiptNo, setReceiptNo] = useState('');
  const [authUser, setAuthUser] = useState(null);
  const [authToken, setAuthToken] = useState(null);

  const token = authToken;
const user = authUser;

  const validationSchema = Yup.object({
    doctorId: Yup.string().required('Select a doctor'),
    appointmentDate: Yup.string().required('Select a date'),
    appointmentTime: Yup.string().required('Select a time'),
    reason: Yup.string()
      .required('Reason is required')
      .test(
        'no-spaces-only',
        'Reason cannot be empty or just spaces',
        (value) => value && value.trim().length > 0,
      ),
    additionalPhone: Yup.string()
      .optional()
      .matches(/^\d{10}$/, 'Additional phone number must be exactly 10 digits'),
  });

useEffect(() => {
  const storedToken = localStorage.getItem("token");
  const storedUser = JSON.parse(localStorage.getItem("user"));

  setAuthToken(storedToken);
  setAuthUser(storedUser);
}, []);

useEffect(() => {
  if (!authUser || !authToken) return;

  if (authUser.hospital_id && authUser.sub_hospital_id) {
    setHospitalId(authUser.hospital_id);
    setSubHospitalId(authUser.sub_hospital_id);

    fetchAppointments();
    fetchDoctors(authUser.hospital_id, authUser.sub_hospital_id);
  } else {
    fetchUserDetails();
  }
}, [authUser, authToken]);


  const fetchUserDetails = async () => {
  try {
    const updatedUser = await fetchData(
      `${BASE_URL}/api/users/${authUser.id}`,
      {},
      { Authorization: `Bearer ${authToken}` }
    );

    localStorage.setItem("user", JSON.stringify(updatedUser));

    setAuthUser(updatedUser);
    setHospitalId(updatedUser.hospital_id || "");
    setSubHospitalId(updatedUser.sub_hospital_id || "");
    setReceiptNo(updatedUser.receipt_no || "");

    setSelectedPatient((prev) => ({
      ...(prev || {}),
      patientName: updatedUser.name,
      patientPhone: updatedUser.phone_number,
      hospital_id: updatedUser.hospital_id,
      subhospital_id: updatedUser.sub_hospital_id,
      receipt_no: updatedUser.receipt_no
    }));

    fetchAppointments();
    fetchDoctors(updatedUser.hospital_id, updatedUser.sub_hospital_id);

  } catch {
    toast.error("Failed to fetch user details.");
  }
};


  const initializeData = (currentUser) => {
    if (!currentUser?.hospital_id || !currentUser?.sub_hospital_id) return;
    fetchAppointments();
    fetchDoctors(currentUser.hospital_id, currentUser.sub_hospital_id);
  };

  const fetchAppointments = async () => {
  const storedPatientId = localStorage.getItem('patient_id');
  if (!storedPatientId) {
    toast.error("Patient ID missing");
    return;
  }

  try {
    const data = await fetchData(
      `${BASE_URL}/api/patient/appointments/${storedPatientId}`,
      {},
      { Authorization: `Bearer ${token}` }
    );

    setAppointments(
      data.map((appointment) => ({
        ...appointment,
        appointmentDateTime: `${appointment.appointmentDate} ${appointment.startTime} - ${appointment.endTime}`
      }))
    );
  } catch {
    toast.error("Failed to fetch appointments");
  }
};


  const fetchDoctors = async (hospitalId, subHospitalId) => {
    if (!hospitalId || !subHospitalId) return; // 🛡️ safety

    try {
      const data = await fetchData(
        `${BASE_URL}/api/patient/doctors`,
        { hospital_id: hospitalId, sub_hospital_id: subHospitalId },
        { Authorization: `Bearer ${token}` },
      );
      setDoctors(data);
    } catch (error) {
      toast.error(
        error?.response?.data?.error ||
          'Failed to fetch doctors. Please try again later.',
      );
    }
  };

  const handleReAppointmentSubmit = async (values, { resetForm }) => {
    const patientId = localStorage.getItem('patient_id');
    const [start_time, end_time] = values.appointmentTime
      .split(' -')
      .map((t) => t.trim());
    const payload = {
      patient_id: patientId,
      patient_name: selectedPatient.patientName,
      patient_phone: selectedPatient.patientPhone,
      doctor_id: values.doctorId,
      appointment_date: values.appointmentDate,
      start_time: `${values.appointmentDate} ${start_time}:00`,
      end_time: `${values.appointmentDate} ${end_time}:00`,
      reason: values.reason,
      hospital_id: selectedPatient.hospital_id,
      subhospital_id: selectedPatient.subhospital_id,
      extraPhone: values.additionalPhone || null,
    };

    try {
      await axios.post(`${BASE_URL}/api/patient/create-appointment`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success('Re-Appointment booked successfully!');
      setShowModal(false);
      fetchAppointments(patientId);
      resetForm();
    } catch {
      toast.error('Error booking re-appointment');
    }
  };

  const handleAppointmentClick = () => {
    if (!token || !user) {
      toast.error(
        'Authentication token or user data is missing. Please log in again.',
      );
      return;
    }
    const u = JSON.parse(localStorage.getItem("user"));

setSelectedPatient({
  id:patientId,
  patientName: u.name,
  patientPhone: u.phone_number,
  hospital_id: u.hospital_id,
  subhospital_id: u.sub_hospital_id,
  receipt_no: u.receipt_no,
});
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedPatient(null);
  };

  const handleDoctorChange = (doctorId, setFieldValue) => {
    setFieldValue('doctorId', doctorId);
    setFieldValue('appointmentDate', '');
    setFieldValue('appointmentTime', '');
    setAvailableTimes([]);
  };

  const handleDateChange = async (date, doctorId, setFieldValue) => {
    setFieldValue('appointmentDate', date);
    setFieldValue('appointmentTime', '');

    if (!doctorId || !date || !user?.hospital_id || !user?.sub_hospital_id) {
      toast.error(
        'Missing required parameters. Please ensure all fields are selected.',
      );
      return;
    }

    try {
      const data = await fetchData(
        `${BASE_URL}/api/patient/doctor-availability`,
        {
          doctor_id: doctorId,
          date,
          hospital_id: user.hospital_id,
          subhospital_id: user.sub_hospital_id,
        },
        { Authorization: `Bearer ${token}` },
      );

      setAvailableTimes(Array.isArray(data) && data.length > 0 ? data : []);
      if (!data.length)
        toast.error('No available times found for the selected date.');
    } catch {
      console.log('Error fetching available times. Please try again later.');
    }
  };

  return (
    <div className="d-flex">
      <Sidebar className="d-none d-md-block" />
      <div className="container-fluid">
        <Row className="mb-4 pt-3 pb-4 align-items-center">
          <Col xs={12} md={6}>
            <h3
              className="mb-0"
              style={{
                fontSize: '1.5rem',
                fontWeight: 'bold',
                color: '#0A7884',
              }}
            >
              Patient Appointments
            </h3>
          </Col>
          <Col
            xs={12}
            md={6}
            className="d-flex justify-content-md-end justify-content-start mt-3 mt-md-0"
          >
            <Button
              style={{
                backgroundColor: '#0A7884',
                border: 'none',
                padding: '10px 20px',
                fontSize: '16px',
                fontWeight: 'bold',
                color: 'white',
                borderRadius: '8px',
              }}
              onClick={handleAppointmentClick}
            >
              Book Appointment
            </Button>
          </Col>
        </Row>

        <Row>
          <Col>
            <Table
              striped
              bordered
              hover
              responsive
              className="shadow-sm"
              style={{ backgroundColor: '#ffffff', borderRadius: '8px' }}
            >
              <thead
                style={{
                  backgroundColor: '#0A7884',
                  color: 'white',
                  fontSize: '14px',
                }}
              >
                <tr>
                  <th>Sr. No.</th>
                  <th>Patient Name</th> {/* Added Patient Name column */}
                  <th>Doctor Name</th>
                  <th>Appointment Date & Time</th>
                  <th>Reason</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody style={{ fontSize: '14px' }}>
                {appointments.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="text-center text-danger">
                      No appointments found.
                    </td>
                  </tr>
                ) : (
                  appointments.map((appointment, index) => (
                    <tr key={appointment.id}>
                      <td>{index + 1}</td>
                      <td>{appointment.patientName}</td>
                      <td>{appointment.doctorName}</td>
                      <td>{appointment.appointmentDateTime}</td>
                      <td>{appointment.appointmentReason}</td>
                      <td
                        className={
                          appointment.status === 'pending'
                            ? 'text-warning fw-bold'
                            : appointment.status === 'confirmed'
                              ? 'text-success fw-bold'
                              : appointment.status === 'rescheduled'
                                ? 'text-danger fw-bold'
                                : ''
                        }
                      >
                        {appointment.status}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </Col>
        </Row>

        <Modal
          show={showModal}
          onHide={handleModalClose}
          centered
          backdrop="static"
          className="custom-modal"
          style={{ borderRadius: '8px' }}
        >
          <Modal.Header
            closeButton
            className="border-0"
            style={{
              backgroundColor: '#f8f9fa',
              borderTopLeftRadius: '8px',
              borderTopRightRadius: '8px',
            }}
          >
            <Modal.Title
              className="form-heading"
              style={{
                color: '#0A7884',
                fontWeight: 'bold',
                fontSize: '18px',
              }}
            >
              {selectedPatient
                ? `Appointment : ${selectedPatient.patientName}`
                : 'Appointment'}
            </Modal.Title>
          </Modal.Header>

          {selectedPatient && (
            <Modal.Body
              className="p-4"
              style={{
                backgroundColor: '#ffffff',
                borderRadius: '8px',
                paddingTop: '10px',
                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
              }}
            >
              <Formik
                initialValues={{
                  doctorId: '',
                  appointmentDate: '',
                  appointmentTime: '',
                  reason: '',
                  additionalPhone: '',
                }}
                validationSchema={validationSchema}
                onSubmit={handleReAppointmentSubmit}
              >
                {({ handleChange, values, setFieldValue, errors, touched }) => (
                  <Form>
                    <div className="mb-3">
                      <label
                        className="fw-semibold"
                        style={{
                          color: 'var(--primary-color)',
                          fontSize: '14px',
                        }}
                      >
                        Patient Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={selectedPatient?.patientName || ''}
                        disabled
                        style={{ backgroundColor: '#e9ecef', fontSize: '14px' }}
                      />
                    </div>
                    <div className="mb-3">
                      <label
                        className="fw-semibold"
                        style={{
                          color: 'var(--primary-color)',
                          fontSize: '14px',
                        }}
                      >
                        Phone Number
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={selectedPatient?.patientPhone || ''}
                        disabled
                        style={{ backgroundColor: '#e9ecef', fontSize: '14px' }}
                      />
                    </div>
                    <div className="mb-3">
                      <label
                        className="fw-semibold"
                        style={{
                          color: 'var(--primary-color)',
                          fontSize: '14px',
                        }}
                      >
                        Doctor
                      </label>
                      <select
                        name="doctorId"
                        className={`form-select ${errors.doctorId && touched.doctorId ? 'is-invalid' : ''}`}
                        value={values.doctorId}
                        onChange={(e) =>
                          handleDoctorChange(e.target.value, setFieldValue)
                        }
                        required
                        style={{ fontSize: '14px' }}
                      >
                        <option value="">Select Doctor</option>
                        {doctors.map((doc) => (
                          <option key={doc.id} value={doc.id}>
                            {doc.name} - {doc.specialties}
                          </option>
                        ))}
                      </select>
                      <ErrorMessage
                        name="doctorId"
                        component="div"
                        className="text-danger mt-1"
                      />
                    </div>
                    <div className="mb-3">
                      <label
                        className="fw-semibold"
                        style={{
                          color: 'var(--primary-color)',
                          fontSize: '14px',
                        }}
                      >
                        Additional Phone Number (Optional)
                      </label>
                      <input
                        type="text"
                        name="additionalPhone"
                        className={`form-control ${errors.additionalPhone && touched.additionalPhone ? 'is-invalid' : ''}`}
                        value={values.additionalPhone}
                        onChange={handleChange}
                        placeholder="Enter additional phone number"
                        style={{ fontSize: '14px' }}
                      />
                      <ErrorMessage
                        name="additionalPhone"
                        component="div"
                        className="text-danger mt-1"
                      />
                    </div>
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <label
                            className="fw-semibold"
                            style={{
                              color: 'var(--primary-color)',
                              fontSize: '14px',
                            }}
                          >
                            Appointment Date
                          </label>
                          <input
                            type="date"
                            name="appointmentDate"
                            className={`form-control ${errors.appointmentDate && touched.appointmentDate ? 'is-invalid' : ''}`}
                            value={values.appointmentDate}
                            onChange={(e) =>
                              handleDateChange(
                                e.target.value,
                                values.doctorId,
                                setFieldValue,
                              )
                            }
                            disabled={!values.doctorId}
                            required
                            style={{ fontSize: '14px' }}
                          />
                          <ErrorMessage
                            name="appointmentDate"
                            component="div"
                            className="text-danger mt-1"
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="mb-3">
                          <label
                            className="fw-semibold"
                            style={{
                              color: 'var(--primary-color)',
                              fontSize: '14px',
                            }}
                          >
                            Appointment Time
                          </label>
                          <select
                            name="appointmentTime"
                            className={`form-select ${errors.appointmentTime && touched.appointmentTime ? 'is-invalid' : ''}`}
                            value={values.appointmentTime}
                            onChange={handleChange}
                            disabled={!values.appointmentDate}
                            required
                            style={{ fontSize: '14px' }}
                          >
                            <option value="">Select Time</option>
                            {availableTimes.map((time) => {
                              const [start, end] = time.split(" - ");
                              const formatTime = (t) => {
                                const [h, m] = t.split(':');
                                const hour = parseInt(h, 10);
                                const suffix = hour >= 12 ? 'PM' : 'AM';
                                const hour12 = hour % 12 === 0 ? 12 : hour % 12;
                                return `${hour12}:${m} ${suffix}`;
                              };

                              const formattedTime = `${formatTime(start)} - ${formatTime(end)}`;

                              return (
                                <option key={time} value={time}>
                                  {formattedTime}
                                </option>
                              );
                            })}
                          </select>
                          <ErrorMessage
                            name="appointmentTime"
                            component="div"
                            className="text-danger mt-1"
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="mb-3">
                      <label
                        className="fw-semibold"
                        style={{
                          color: 'var(--primary-color)',
                          fontSize: '14px',
                        }}
                      >
                        Reason
                      </label>
                      <textarea
                        name="reason"
                        className={`form-control ${errors.reason && touched.reason ? 'is-invalid' : ''}`}
                        rows="3"
                        value={values.reason}
                        onChange={handleChange}
                        required
                        style={{ fontSize: '14px' }}
                      ></textarea>
                      <ErrorMessage
                        name="reason"
                        component="div"
                        className="text-danger mt-1"
                      />
                    </div>
                    <Row>
                      <Col md={4}>
                        <div className="mb-3">
                          <label
                            className="fw-semibold"
                            style={{
                              color: 'var(--primary-color)',
                              fontSize: '14px',
                            }}
                          >
                            Receipt No
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={receiptNo}
                            disabled
                            style={{
                              backgroundColor: '#e9ecef',
                              fontSize: '14px',
                            }}
                          />
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="mb-3">
                          <label
                            className="fw-semibold"
                            style={{
                              color: 'var(--primary-color)',
                              fontSize: '14px',
                            }}
                          >
                            Hospital ID
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={hospitalId}
                            disabled
                            style={{
                              backgroundColor: '#e9ecef',
                              fontSize: '14px',
                            }}
                          />
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="mb-3">
                          <label
                            className="fw-semibold"
                            style={{
                              color: 'var(--primary-color)',
                              fontSize: '14px',
                            }}
                          >
                            Subhospital ID
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={subHospitalId}
                            disabled
                            style={{
                              backgroundColor: '#e9ecef',
                              fontSize: '14px',
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Button
                      type="submit"
                      variant="primary"
                      className="btn-custom w-100"
                      style={{
                        backgroundColor: '#0A7884',
                        border: 'none',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        padding: '10px',
                        borderRadius: '8px',
                        color: 'white',
                      }}
                    >
                      Submit
                    </Button>
                  </Form>
                )}
              </Formik>
            </Modal.Body>
          )}
        </Modal>
      </div>
    </div>
  );
};

export default Appointment;
